import React, { useCallback, useRef, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { Button } from 'react-bootstrap';

import SelectAsync, { IResponse } from '../SelectAsync';
import { ProfileFormDados } from '../Agendamento';
import PacienteCadastro from '../PacienteCadastro';
import Modal from '../Modal';

type Props = {
  loading: boolean;
  handleSelectCliente({ value }: IResponse): void;
};

const BuscaPaciente: React.FC<Props> = ({ loading, handleSelectCliente }) => {
  const formRefPaciente = useRef<FormHandles>(null);
  const [showModalPacienteCad, setShowModalPacienteCad] = useState(false);

  const handleCadastrouPac = useCallback((PacCodigo: number) => {
    if (PacCodigo) {
      setShowModalPacienteCad(false);
      handleSelectCliente({ value: PacCodigo.toString(), label: '' });
    }
  }, []);

  const handleSubmitPaciente = useCallback((dados: ProfileFormDados) => {
    console.log('foi', dados);
  }, []);

  return (
    <>
      {showModalPacienteCad && (
        <Modal
          titulo="Cadastro de Paciente"
          show={showModalPacienteCad}
          handleFecharModal={
            () => {
              setShowModalPacienteCad(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <PacienteCadastro
            exibeMenu={false}
            pacCodigo={undefined}
            handleRetornaDados={dados => handleCadastrouPac(dados.PacCodigo)}
          />
        </Modal>
      )}

      <Form
        ref={formRefPaciente}
        style={{ minHeight: '300px', padding: '.5rem' }}
        onSubmit={handleSubmitPaciente}
      >
        <SelectAsync
          name="pacienteID"
          label="Nome do Paciente"
          urlApi="pacientes/combo?termoBusca="
          placeholder="Digite para buscar"
          handleSelectChange={handleSelectCliente}
        />

        <Button
          className={loading ? 'd-none' : 'mt-3'}
          variant="outline-primary"
          size="sm"
          onClick={() => setShowModalPacienteCad(true)}
          disabled={loading}
        >
          Novo Paciente
        </Button>
      </Form>
    </>
  );
};

export default BuscaPaciente;
